import { useEffect } from "react";

interface UseFireworkPlayerEventsParams {
  readonly enabled: boolean;
  readonly onTransition?: (event: Event) => void;
  readonly onQuit?: (event: Event) => void;
}

export function useFireworkPlayerEvents({
  enabled,
  onTransition,
  onQuit,
}: Readonly<UseFireworkPlayerEventsParams>) {
  useEffect(() => {
    if (!enabled) return;

    if (onTransition) {
      document.addEventListener("fw:player:transition", onTransition);
      window.addEventListener("fw:player:transition", onTransition as EventListener);
    }

    if (onQuit) {
      document.addEventListener("fw:player:quit", onQuit);
      window.addEventListener("fw:player:quit", onQuit as EventListener);
    }

    return () => {
      if (onTransition) {
        document.removeEventListener("fw:player:transition", onTransition);
        window.removeEventListener("fw:player:transition", onTransition as EventListener);
      }

      if (onQuit) {
        document.removeEventListener("fw:player:quit", onQuit);
        window.removeEventListener("fw:player:quit", onQuit as EventListener);
      }
    };
  }, [enabled, onTransition, onQuit]);
}
